import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "./core/services/app.service";

declare let gtag: Function;
@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
})
export class AppComponent {
	title = "focuspos-online-order";

	constructor(public router: Router, public app: AppService) {}
}
//G-XZ9NMEKSX3
